import { batchPickPointedEnums } from "../common/pickPointedEnum";
import { getEnumApi } from "@/services/common";
import type { Config } from "../type";
import useSWR from "swr";

const useEnums = (configs: Config[] = []) => {
  const { data = {} } = useSWR(
    "oam_enums",
    async () => {
      const res = await getEnumApi();
      if (res.success) {
        return res.model;
      }
    },
    {
      dedupingInterval: 1000 * 60 * 30,
    },
  );

  return batchPickPointedEnums(configs, data);
};

export default useEnums;
